import React from 'react';
import DescriptionsFormItem from '@mpc/common/src/components/DescriptionsFormItem';
import ContactTable from './ContactTable';
import BankAccount from '@mpc/common/src/features/BankAccount';

interface Props {
  view: boolean;
  mdm_code?: string;
}

const ContractInformation = ({
  view,
  mdm_code,
}: Props) => {
  return (
    <DescriptionsFormItem
      items={
        [
          {
            formItemKey: 'contract_contact_info',
            label: '合同联系人',
            span: 2,
            render: () => {
              return <ContactTable view={view} />
            }
          },
          {
            formItemKey: 'bank_info',
            label: '银行账户',
            span: 1,
            render: () => {
              return <BankAccount view={view} mdm_code={mdm_code} showAddBank />
            }
          },
        ]
      }
    >
    </DescriptionsFormItem>
  )
}

export default ContractInformation;
